// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as PartnerScoreAssetManager from "../../assets/PartnerScoreAssetManager.bs.js";

function ScoreMessageIconCmp(Props) {
  var icon_path = Props.icon_path;
  return React.createElement("img", {
              className: "score-message-icon",
              src: PartnerScoreAssetManager.getImage(icon_path)
            });
}

var make = ScoreMessageIconCmp;

export {
  make ,
  
}
/* react Not a pure module */
